import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const SignUp = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
  });

  const BASE_URL = process.env.REACT_APP_BASE_URL;
   const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
  const [showModal, setShowModal] = useState(true); // Show modal on page load
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${BASE_URL}/user/registerAdmin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 403) {
        throw new Error('Forbidden: Check your authorization token or API permissions.');
      }

      const result = await response.json();

      if (result.status?.statusCode === 200) {
        setSuccessMessage(result.status.message);
        console.log('Response Data:', result.data);
        setShowModal(false); // Close modal on successful registration
        navigate('/');
      } else {
        setErrorMessage(result.status?.message || 'Registration failed.');
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('An error occurred during registration.');
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
           <Form.Group className="mb-3">
             <Form.Label>First Name</Form.Label>
             <Form.Control
               type="text"
               placeholder="First Name"
               name="firstName"
               value={formData.firstName}
               onChange={handleInputChange}
               required
             />
           </Form.Group>
           <Form.Group className="mb-3">
             <Form.Label>Last Name</Form.Label>
             <Form.Control
               type="text"
               placeholder="Last Name"
               name="lastName"
               value={formData.lastName}
               onChange={handleInputChange}
               required
             />
           </Form.Group>
           <Form.Group className="mb-3">
             <Form.Label>Email</Form.Label>
             <Form.Control
               type="email"
               placeholder="Email"
               name="email"
               value={formData.email}
               onChange={handleInputChange}
               required
             />
           </Form.Group>
           <Form.Group className="mb-3">
             <Form.Label>Phone Number</Form.Label>
             <Form.Control
               type="text"
               placeholder="Phone Number"
               name="phoneNumber"
               value={formData.phoneNumber}
               onChange={handleInputChange}
               required
             />
           </Form.Group>
           <Button variant="primary" type="submit" className="w-100">
             Sign Up
           </Button>
         </Form>
         <p style={{paddingTop: '10px'}}>
         {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
         {successMessage && <Alert variant="success">{successMessage}</Alert>}
         </p>
    </>
  );
};

export default SignUp;
